import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { RxComponent } from 'app/core/components/common/rx.component';
import { RequestService } from 'app/core/services/request.service';

@Component({
  selector: 'itpx-final-step',
  templateUrl: './final-step.component.html',
  styleUrls: ['./final-step.component.css']
})
export class FinalStepComponent extends RxComponent implements OnInit {

  @Input() selectedTopicId: string;
  @Input() selectedTopicTitle: string;
  @Input() catalogName: string;
  @Input() url: string;
  @Output() stepBack: EventEmitter<any> = new EventEmitter();

  constructor(
    // private service: ProductSellerService,
    private modalService: SmartModalService,
    private requestService: RequestService
  ) { super() }

  private categoryList: Array<any>;
  private selectedTopicName: string;
  private categoryDictionary: Array<any>;
  private hideCategoryMsg: boolean = false;
  private selectedCategoryKey: string;

  ngOnInit() {
    this.requestService.get(this.url + '/' + this.selectedTopicId)
      .bindToLifecycle(this)
      .subscribe(
        body => {
          this.categoryDictionary = body.data;
          this.categoryList = [...this.categoryDictionary].map(cat => { return { key: cat.id, value: cat.name } });
          // if (this.categoryList.length === 1) this.selectedCategoryKey = this.categoryList[0].key;
          // this.hideCategoryMsg = false;
        }
      )

  }

  onTileClicked(e) {
    let category = this.categoryDictionary.find(cat => cat.id === e.key);
    this.modalService.sendResult(category);
  }

  back() {
    let templateKey = 'topic-select-template';
    this.stepBack.emit({ templateKey: templateKey, name: 'reset-topic' });
  }

  onCancel() {
    this.modalService.close()
  }
  reset() {
    let templateKey = 'main-category-select-template';
    this.stepBack.emit({ templateKey: templateKey, name: 'reset' });
  }

  cropText(t): string {
    if (t) {
      return t.substring(0, 22);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal/catalog-modal/steps/final-step/final-step.component.ts